import React, { useCallback, useRef, useEffect } from 'react';
import BScroll from '@better-scroll/core';
import { renderFloat } from '@/utils/fn';
import { reportClick } from '@/utils/report';
import { openPageNative } from '@/utils/bridge';
import { jumpToPageByH5 } from '@/utils/fn';
import { LINK_PREFIX_MAP, DISTRIBUTION_MAP } from '../const';
import styles from '../index.less';

const ActIncome = ({
  type = 'group',
  pageName,
  distribution,
  setModalStatus,
  // adsInfo = {},
}) => {
  const bsScrollContainer = useRef(null);

  const handleIncomeItemClick = (type = 'invite') => {
    reportClick({
      page_name: pageName,
      button_name: `${type}_reward_btn`,
    });
    switch (type) {
      case 'online':
        jumpToPageByH5('/reward/online?origin=daily');
        break;
      case 'x86':
        jumpToPageByH5('/invite/x86/inviter?origin=daily');
        break;
      case 'invite':
        jumpToPageByH5('/invite/inviter?origin=daily');
        break;
      case 'contribution':
        setModalStatus(true, type);
        break;
      case 'other':
        setModalStatus(true, type);
        break;
      default:
        setModalStatus(true, type);
        break;
    }
  };

  useEffect(() => {
    let bsScroll;
    if (distribution?.length > 0 && bsScrollContainer.current) {
      bsScroll = new BScroll(bsScrollContainer.current, {
        scrollX: true,
        click: true,
        eventPassthrough: 'vertical',
      });
    }
    return () => bsScroll?.destroy();
  }, [distribution]);

  return (
    <div className={`${styles['ubox']} ${styles['act-reward']}`}>
      <div className={styles.actIncome}>
        <p>收益分布</p>
      </div>
      <div className={styles.rewardListWrapper} ref={bsScrollContainer}>
        {distribution && distribution.length > 0 && (
          <ul className={styles['act-reward-list']}>
            {distribution.map((item, idx) => (
              <li
                className={
                  DISTRIBUTION_MAP[item.is].ename === 'invite' ||
                  DISTRIBUTION_MAP[item.is].ename === 'x86' ||
                  DISTRIBUTION_MAP[item.is].ename === 'online'
                    ? styles.withTip
                    : ''
                }
                key={idx}
                onClick={() => handleIncomeItemClick(DISTRIBUTION_MAP[item.is].ename)}
              >
                {/* {DISTRIBUTION_MAP[item.is].ename === 'x86' && (
                  <span className={styles.tag}>限时高奖励</span>
                )} */}
                <h4 className={styles['reward-title']}>{DISTRIBUTION_MAP[item.is].name}</h4>
                <p className={styles.rewardName}>现金</p>
                <p className={styles.rewardVal}>{renderFloat(item.c)}</p>
                <p className={styles.rewardName}>云豆</p>
                <p className={styles.rewardVal}>{item.cb}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
export default ActIncome;
